export default function getCurrentRoute() {
  var body = document.getElementsByTagName("body")[0];
  return body.getAttribute('data-route');
}
